import { render, staticRenderFns } from "./AppCropperWebCam.vue?vue&type=template&id=2dcff0f5&"
import script from "./AppCropperWebCam.vue?vue&type=script&lang=js&"
export * from "./AppCropperWebCam.vue?vue&type=script&lang=js&"
import style0 from "./AppCropperWebCam.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports